// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduce } from 'lodash';
import { indicationDelete } from '../../actions/indication';

type Props = {
  isLoading: Object,
  indicationDelete: typeof indicationDelete
};

class Indication extends React.PureComponent<Props> {
  render() {
    return (
      <div className="page-indication">
        {reduce(
          this.props.isLoading,
          (acc, messages, messagesKey) => {
            if (!Array.isArray(messages) || messages.length === 0) {
              return acc;
            }

            const isAsync = messages.some(({ async }) => async === true);
            if (!isAsync) {
              // TODO set timeout not in render, but in receive props
              setTimeout(() => {
                indicationDelete(messagesKey);
              }, 8000);
            }

            if (typeof messages === 'function') {
              return acc;
            }

            return acc.concat(
              messages.map(message => (
                <div key={message.id}>
                  <div
                    className={`indication-alert ${message.type}`}
                    dangerouslySetInnerHTML={{ __html: message.text }}
                  />
                </div>
              ))
            );
          },
          []
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.IndicationReducer.isLoading
  };
}

export default connect(
  mapStateToProps,
  indicationDelete
)(Indication);
